export class SaveFile {
    constructor () {      
        this.header = ['DIV_KUBUN','BIZ_KUBUN','SITE_CODE','USER_KUBUN','SUB_DIR','RENAME_YN','FILE_NAME','FILE_ID','file'];        
        this.data = [{
          DIV_KUBUN: '',
          BIZ_KUBUN: '',
          SITE_CODE: '',
          USER_KUBUN: '',
          SUB_DIR: '',          
          RNAME_YN: '',
          FILE_ID: '',    // if exist FILE_ID, Save to the file, If there is no FILE_ID, New file will be created and then save to it.
          FILE_NAME: '',
          file:''
        }];        
    }
}